import React, { useState } from 'react';
import moment from "moment"
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import { CSVLink } from "react-csv";

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import { Card, Dialog, DialogActions, DialogContent, IconButton, InputAdornment, MenuItem, Select, TextField, Typography } from '@material-ui/core';

// @material-ui/icons
import { ReactComponent as CSVIcon } from "assets/img/tuzo/icons/CSVIcon.svg";
import { Search } from '@material-ui/icons';
import { AiOutlineCaretLeft, AiOutlineCaretRight } from 'react-icons/ai';


// stylings
import Style from 'assets/jss/material-dashboard-pro-react/views/reportsStyle';
import withStyles from '@material-ui/core/styles/withStyles';

export function ReportsFilter(props) {
    const {
        classes,
        history,
        sortValue,
        fromDate,
        reportSelections,
        headers,
        numberFormatterDecimals,
        numberFormatter,
        searchString,
        setSearchString,
        handleSearch,
        csvData,
        dateFilter,
        increaseDate,
        decreaseDate,
        dateCheck,
        allLoaded,
        allBatch,
        csvAllHeaders
    } = props;

    const [filteredData, setFilteredData] = useState([])

    const filterReport = () => {
        const endOfMonth = moment(dateFilter).endOf('month').format("MM/DD/YY")
        const firstOfMonth = moment(dateFilter).startOf('month').format("MM/DD/YY")
        const filtered = csvData.filter((f) => {
            if (f.deactivated === undefined) {
                return false
            }
            if (f.deactivated){
                let formatDeactivateDate =  moment.unix(f.deactivatedDate.seconds).format("MM/DD/YY")
                if (moment(formatDeactivateDate).isSameOrBefore(firstOfMonth)){
                    return false
                }
            }
            if (f.boardDate) {
                let formatBoardDate = moment.unix(f.boardDate.seconds).format("MM/DD/YY")
                if (moment(formatBoardDate).isSameOrBefore(endOfMonth)) {
                    return true
                }

            }
            if (f.boardDate === undefined) {
                return true
            }
        })
        setFilteredData(filtered)
    }


    return (
        <div>
            <GridContainer>
                <GridItem xs={4} >
                    <div style={{ display: "flex", }}>
                        <Typography variant="h2" className={classes.filterDesc} >
                            Switch Report
                        </Typography>
                        <Select
                            className={classes.selectMenuSortReportsPage}
                            value={sortValue}
                            disableUnderline
                            classes={{
                                root: classes.selectText,
                            }}
                            onChange={(e) => {
                                history.push(e.target.value.link)
                            }}
                            displayEmpty
                            renderValue={
                                sortValue !== "" ? undefined : () => "Sales by Merchant"
                            }
                        >
                            {reportSelections.map((o, i) => {
                                return (
                                    <MenuItem
                                        key={i}
                                        value={o}
                                        classes={{
                                            root: classes.selectMenuItem,
                                        }}
                                    >
                                        {o.name}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </div>
                </GridItem>

                <GridItem xs={4}>
                    <TextField
                        style={{ width: "100%" }}
                        className={classes.searchBar}
                        value={searchString}
                        onChange={(e) => setSearchString(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearch();
                            }
                        }}
                        InputProps={{
                            disableUnderline: true,
                            classes: {
                                // adornedEnd: classes.adournedEnd,
                                input: classes.input
                            },
                            endAdornment: (
                                <InputAdornment className={classes.adournedEnd} position="end">
                                    <Button
                                        onClick={() => handleSearch()}
                                        className={classes.searchButton}>
                                        <Search style={{ marginRight: "5px", marginTop: "-4px" }} />
                                        Search
                                    </Button>
                                </InputAdornment>
                            ),
                        }}
                    />
                </GridItem>

                <GridItem xs={2} style={{ display: "flex", justifyContent: "flex-end", }}>

                    <Button
                        className={classes.csvButton}
                        disabled={!allLoaded}
                    >
                        <CSVLink
                            style={{ color: "white" }}
                            headers={csvAllHeaders}
                            data={
                                allBatch.filter(d => d.demo === undefined || d.demo === false).map((d) => ({
                                    isoName: d.IsoAdminCompanyName,
                                    merchantNumber: d.merchantNumber,
                                    name: d.merchantName,
                                    quantity: d.totalTransactions,
                                    pointsEarned: numberFormatter.format(d.pointsEarned),
                                    dayTotal: numberFormatterDecimals.format(d.netAmount),
                                    reportDate: (d.reportDate) ? moment(d.reportDate).format("MM/DD/YY") : "N/A",
                                    userBasisPts: d.userBasisPts,
                                    boardDate: d.boardDate ? moment.unix(d.boardDate.seconds).format("MM/DD/YY") : "N/A",
                                    deactivatedDate: d.deactivatedDate ? moment.unix(d.deactivatedDate.seconds).format("MM/DD/YY") : "N/A"
                                }))
                            }
                            filename={`${moment(dateFilter).format('MMM') + "_" + moment(dateFilter).format('YYYY')}_Report`}
                        >
                            <CSVIcon style={{ marginRight: "10px", }} /> Export All

                        </CSVLink>
                    </Button>
                </GridItem>


                <GridItem xs={2} style={{ display: "flex", justifyContent: "flex-end", }}>
                    <Button
                        className={classes.csvButton}
                        onClick={() => filterReport()}
                    >
                        <CSVLink
                            style={{ color: "white" }}
                            headers={headers}
                            data={
                                filteredData.filter(d => d.demo === undefined || d.demo === false).map((d) => ({
                                    isoName: d.IsoAdminCompanyName,
                                    merchantNumber: d.merchantNumber,
                                    name: d.merchantName,
                                    quantity: d.totalTransactions,
                                    pointsEarned: numberFormatter.format(d.totalPointsEarned),
                                    monthTotal: numberFormatterDecimals.format(d.totalNetAmount),
                                    reportDate: (d.reportDate) ? moment(d.reportDate).format("MM/DD/YY") : "N/A",
                                    userBasisPts: d.userBasisPts,
                                    boardDate: d.boardDate ? moment.unix(d.boardDate.seconds).format("MM/DD/YY") : "N/A",
                                    deactivatedDate: d.deactivatedDate ? moment.unix(d.deactivatedDate.seconds).format("MM/DD/YY") : "N/A"
                                }))
                            }
                            filename={`${moment(dateFilter).format('MMM') + "_" + moment(dateFilter).format('YYYY')}_Report`}
                        >
                            <CSVIcon style={{ marginRight: "10px", }} /> Export CSV

                        </CSVLink>
                    </Button>
                </GridItem>

                <GridItem xs={3} style={{ display: "flex", justifyContent: "space-between", margin: "10px 0px" }}>
                    <IconButton
                        className={classes.adminArrows}
                        onClick={() => decreaseDate(dateFilter)}
                    >
                        <AiOutlineCaretLeft style={{ color: "white", marginRight: "2px" }} />
                    </IconButton>
                    <span className={classes.date}>
                        {dateFilter}
                    </span>

                    <IconButton
                        disabled={dateCheck}
                        className={classes.adminArrows}
                        onClick={() => increaseDate(dateFilter)}
                    >
                        <AiOutlineCaretRight style={{ color: "white", marginLeft: "2px" }} />
                    </IconButton>
                </GridItem>
            </GridContainer>
        </div >
    );
}

function mapStateToProps(state) {
    return {
        // nothing yet
    };
}

function mapDispatchToProps(actions) {
    return (dispatch) => ({

    });
}

export default withRouter(compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(ReportsFilter));
